import { ComponentType, EventSource, InteractionType, MixpanelEvent } from '../MixPanelTypes';

export type DialogEvents = 'DIALOG_SHOW' | 'DIALOG_CLOSE_CLICK' | 'DIALOG_CONFIRM_CLICK' | 'DIALOG_CANCEL_CLICK';

export const dialog: Record<DialogEvents, MixpanelEvent> = {
  DIALOG_SHOW: {
    eventDescription: 'Dialog Show',
    eventKey: 'dialog-show',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG
  },
  DIALOG_CLOSE_CLICK: {
    eventDescription: 'Dialog Close Click',
    eventKey: 'dialog-close-click',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.CLOSE_BUTTON
  },
  DIALOG_CONFIRM_CLICK: {
    eventDescription: 'Dialog Confirm Click',
    eventKey: 'dialog-confirm-click',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_CONFIRM_BUTTON
  },
  DIALOG_CANCEL_CLICK: {
    eventDescription: 'Dialog Cancel Click',
    eventKey: 'dialog-cancel-click',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_CANCEL_BUTTON
  }
} as const;

export type DialogEventDetails = {
  dialogTitle: string;
};
